import { computed, signal } from 'alien-deepsignals'

const lockLevel = signal(0)
const sharedLockLevel = signal(0)

export const lock = computed(() => lockLevel.get() > 0 || sharedLockLevel.get() > 0)
const bc = new BroadcastChannel('research_chat_lock_channel')

bc.addEventListener('message', (event) => sharedLockLevel.set(sharedLockLevel.get() + event.data))

export function lockIncrease() {
  bc.postMessage(1)

  lockLevel.set(lockLevel.get() + 1)
}

export function lockDecrease() {
  bc.postMessage(-1)

  if (lockLevel.get() < 1) return
  lockLevel.set(lockLevel.get() - 1)
}
